import axios from '@/services/axios'

export default {
  sendSubmission (data) {
    return axios.post('/dealroom-interests', data)
  },
  resetPassword (data) {
    return axios.post('/users/reset-password', data)
  },
  resetPasswordToken (data) {
    return axios.post('/users/reset-password/tokens', data)
  }
}
